(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[634],{

/***/ 9863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5713);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_ps_devs_shopify_webpack_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n*[data-v-1b12723a] {\n  will-change        : height, padding-top, padding-bottom, margin-top, margin-bottom, opacity;\n  transform          : translateZ(0);\n  backface-visibility: hidden;\n  perspective        : 1000px;\n}\n.expand-enter-active[data-v-1b12723a],\n.expand-leave-active[data-v-1b12723a] {\n  transition: height .4s ease-in-out,\n              padding-top .4s ease-in-out,\n              padding-bottom .4s ease-in-out,\n              margin-top .4s ease-in-out,\n              margin-bottom .4s ease-in-out,\n              opacity .2s ease-in-out;\n  overflow  : hidden;\n}\n.expand-enter[data-v-1b12723a],\n.expand-leave-to[data-v-1b12723a] {\n  height        : 0;\n  padding-top   : 0;\n  padding-bottom: 0;\n  margin-top    : 0;\n  margin-bottom : 0;\n  opacity       : 0;\n}\n", ""]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9887:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var scripts_utils_smoothscroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4836);
/* harmony import */ var scripts_utils_smoothscroll__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(scripts_utils_smoothscroll__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var scripts_vue_main__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3200);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9346);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 * @file vendors@template.collection.js
 * @file template.collection.js
 *
 */






window.PSTheme.Vue.Collection = new (vue__WEBPACK_IMPORTED_MODULE_2___default())({
  name: 'CollectionWrapper',
  components: {
    'collection': (__webpack_require__(8371)/* ["default"] */ .Z)
  }
}).$mount('.collection');

/***/ }),

/***/ 9508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ mq_breakpoints; },
/* harmony export */   "ku": function() { return /* binding */ px_breakpoints; }
/* harmony export */ });
/* unused harmony export px_queries */
// EMs
let mq_breakpoints = {
  '--mobile-down': '(max-width: 25.99em)',
  '--mobile-up': '(min-width: 26em)',
  '--phablet-down': '(min-width: 32.49em)',
  '--phablet-up': '(min-width: 32.5em)',
  '--tablet-down': '(max-width: 39.99em)',
  '--tablet-up': '(min-width: 40em)',
  '--tablet-lg-down': '(min-width: 63.99em)',
  '--tablet-lg-up': '(min-width: 64em)',
  '--laptop-down': '(max-width: 71.99em)',
  '--laptop-up': '(min-width: 72em)',
  '--desktop-down': '(max-width: 99.99em)',
  '--desktop-up': '(min-width: 100em)',
  '--ultrawide': '(min-width: 125em)'
}; // Pixels

let px_breakpoints = {
  '--mobile-up': 416,
  '--phablet-up': 520,
  '--tablet-up': 640,
  '--tablet-lg-up': 1024,
  '--laptop-up': 1152,
  '--desktop-up': 1600,
  '--ultrawide': 2000
};
let px_queries = {
  '--mobile-up': '(min-width: 416px)',
  '--phablet-up': '(min-width: 520px)',
  '--tablet-up': '(min-width: 640px)',
  '--tablet-lg-up': '(min-width: 1024px)',
  '--laptop-up': '(min-width: 1152px)',
  '--desktop-up': '(min-width: 1600px)',
  '--ultrawide': '(min-width: 2000px)'
};


/***/ }),

/***/ 4836:
/***/ (function() {

// Element to move, time in ms to animate
window.scrollTo = function (element, duration) {
  var e = document.documentElement;

  if (e.scrollTop === 0) {
    var t = e.scrollTop;
    ++e.scrollTop;
    e = t + 1 === e.scrollTop-- ? e : document.body;
  }

  scrollToC(e, e.scrollTop, element, duration);
}; // Element to move, element or px from, element or px to, time in ms to animate


function scrollToC(element, from, to, duration) {
  if (duration <= 0) return;
  if (typeof from === "object") from = from.offsetTop;
  if (typeof to === "object") to = to.offsetTop;
  scrollToX(element, from, to, 0, 1 / duration, 20, easeOutCuaic);
}

function scrollToX(element, xFrom, xTo, t01, speed, step, motion) {
  if (t01 < 0 || t01 > 1 || speed <= 0) {
    element.scrollTop = xTo;
    return;
  }

  element.scrollTop = xFrom - (xFrom - xTo) * motion(t01);
  t01 += speed * step;
  setTimeout(function () {
    scrollToX(element, xFrom, xTo, t01, speed, step, motion);
  }, step);
}

function easeOutCuaic(t) {
  t--;
  return t * t * t + 1;
}

/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./src/scripts/vue/store/global.js

const store = vue_min_default().observable({
  menuActive: false,
  searchActive: false,
  notificationsActive: false,
  closeAnnouncement: false,
  customerCountry: 'NZ'
});
const actions = {
  openMenu() {
    store.menuActive = true;
  },

  toggleMenu() {
    if (store.menuActive) {
      this.closeAll();
    } else {
      this.closeAll();
      store.menuActive = true;
    }
  },

  toggleSearch() {
    store.searchActive = !store.searchActive;
  },

  toggleNotifications() {
    store.notificationsActive = !store.notificationsActive;
  },

  closeAll() {
    store.menuActive = false;
    store.searchActive = false;
    store.notificationsActive = false;
    window.PSTheme.Vue.Header.secondMenuIdx = null;
    window.PSTheme.Vue.Header.thirdMenuIdx = null;
  }

};
(vue_min_default()).prototype.$store = store;
(vue_min_default()).prototype.$actions = actions;
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
// EXTERNAL MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.mjs
var vue_composition_api = __webpack_require__(5706);
// EXTERNAL MODULE: ./node_modules/vue-screen/dist/vue-screen.esm.js
var vue_screen_esm = __webpack_require__(6768);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/currency.js
var currency = __webpack_require__(1186);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-images/images.js
var theme_images_images = __webpack_require__(3253);
;// CONCATENATED MODULE: ./src/scripts/vue/main.js







/* config */

(vue_min_default()).config.devtools = true;
(vue_min_default()).config.productionTip = false;
(vue_min_default()).config.silent = true;
/* extensions */

(vue_min_default()).prototype.$language = window.PSTheme.Language;
(vue_min_default()).prototype.$settings = window.PSTheme.Settings;

(vue_min_default()).prototype.$image = (src, size = '750x') => theme_images_images/* getSizedImageUrl */.M0(src, size);

(vue_min_default()).prototype.$preloadImages = (imgArray, size = '750x') => theme_images_images/* preload */.MA(imgArray, size);

(vue_min_default()).prototype.$money = amount => (0,currency/* formatMoney */.l)(amount, '${{amount}}');

(vue_min_default()).prototype.$isEmpty = obj => {
  if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true;
};
/* plugins */


vue_min_default().use(vue_composition_api/* default */.ZP);
vue_min_default().use(vue_screen_esm/* default */.Z, {
  mobile_up: breakpoints/* px_breakpoints.--mobile-up */.ku["--mobile-up"],
  tablet_up: breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"],
  tablet_lg_up: breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"],
  laptop_up: breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"],
  desktop_up: breakpoints/* px_breakpoints.--desktop-up */.ku["--desktop-up"]
});

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Loading; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[ 'site-loading', { 'activated': _vm.props.activated }],staticStyle:{"z-index":"100"}},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"circle one"}),_vm._v(" "),_c('div',{staticClass:"circle two"})])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Loadingvue_type_script_lang_js_ = ({
  name: 'Loading',
  props: ['activated']
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Loadingvue_type_script_lang_js_ = (Loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_Loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var Loading = (component.exports);

/***/ }),

/***/ 3023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VImg; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=template&id=ad5c73c6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"lazyload vimg",class:_vm.customClass,attrs:{"src":_vm.dataURL,"data-src":_vm.fixedSize ? _vm.$image(_vm.media.src, _vm.fixedSize) : _vm.$image(_vm.media.src),"data-srcset":_vm.fixedSize ? '' : _vm.srcset,"data-sizes":"auto","alt":_vm.media.alt || _vm.$attrs.alt || 'Image'},on:{"lazyloaded":function($event){return _vm.$emit('loaded')}}})}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VImgvue_type_script_lang_js_ = ({
  name: 'VImg',
  props: ['media', 'fixedSize', 'customClass'],
  computed: {
    srcset() {
      if (this.fixedSize) return null;
      let srcset = this.$image(this.media.src, '200x') + ' 100w';
      this.media.width >= 200 ? srcset += `, ${this.$image(this.media.src, '400x')} 200w` : '';
      this.media.width >= 400 ? srcset += `, ${this.$image(this.media.src, '800x')} 400w` : '';
      this.media.width >= 600 ? srcset += `, ${this.$image(this.media.src, '1200x')} 600w` : '';
      this.media.width >= 800 ? srcset += `, ${this.$image(this.media.src, '1600x')} 800w` : '';
      this.media.width >= 1000 ? srcset += `, ${this.$image(this.media.src, '2000x')} 1000w` : '';
      this.media.width >= 1500 ? srcset += `, ${this.$image(this.media.src, '3000x')} 1500w` : '';
      this.media.width >= 2000 ? srcset += `, ${this.$image(this.media.src, '4000x')} 2000w` : '';
      return srcset;
    },

    // This will stop content reflow issue by supplying src attr with image aspect as a canvas
    dataURL() {
      const width = this.media.width;
      const height = this.media.height;
      if (!width || !height) return '';
      const w = 100;
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = height / width * w;
      return canvas.toDataURL();
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VImgvue_type_script_lang_js_ = (VImgvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_VImgvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VImg = (component.exports);

/***/ }),

/***/ 8371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Collection; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/templates/Collection.vue?vue&type=template&id=c74769f0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.products_count > 0 || _vm.template === 'search')?_c('div',{staticClass:"collection__container"},[(_vm.template === 'search')?_c('header',{staticClass:"search__header header__title"},[_c('h1',{staticClass:"outline single-word",style:(("--text:'" + (_vm.$language.search.title) + "'"))},[_vm._v("\n      "+_vm._s(_vm.$language.search.title)+"\n    ")]),_vm._v(" "),_c('form',{staticClass:"search__header-form",attrs:{"action":"/search","method":"get","role":"search"}},[_c('input',{staticClass:"search__header-input",attrs:{"type":"search","name":"q","autocomplete":"off","placeholder":_vm.query,"id":"SearchInput"}})])]):_vm._e(),_vm._v(" "),_c('SearchaniseFilters',{attrs:{"api_key":_vm.api_key,"id":_vm.id,"handle":_vm.handle,"query":_vm.query,"productsPerPage":_vm.productsPerPage,"page":_vm.currentPage,"sort_order":_vm.sort_order},on:{"resetPage":function($event){_vm.currentPage = 1},"updatePage":function($event){_vm.currentPage = $event}}}),_vm._v(" "),_c('div',{staticClass:"collection-count"},[_c('small',[_vm._v(_vm._s(_vm.state.filterProductsCount)+" results")])]),_vm._v(" "),_c('div',{staticClass:"collection-grid"},[(_vm.state.loading)?_vm._l((_vm.productsPerPage),function(idx){return _c('PlaceholderItem',{key:idx,attrs:{"ratio":".65","type":"product-item"}})}):_vm._l((_vm.state.products),function(product){return _c('SearchaniseItem',{key:product.product_id,attrs:{"product":product,"collection":_vm.handle,"label_conf":_vm.label_conf}})})],2),_vm._v(" "),(_vm.numberOfPages > 1)?_c('nav',{attrs:{"role":"navigation","aria-label":"Pagination"}},[_c('Pagination',{attrs:{"page-count":_vm.numberOfPages,"classes":_vm.$options.paginationClasses,"labels":_vm.$options.paginationLabels},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1):_vm._e()],1):_c('div',{staticClass:"no-results"},[_c('h4',[_vm._v("Sorry, no products found")])])}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/vue-plain-pagination/dist/vue-plain-pagination.umd.min.js
var vue_plain_pagination_umd_min = __webpack_require__(5269);
var vue_plain_pagination_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_plain_pagination_umd_min);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/SearchaniseFilters.vue?vue&type=template&id=dea1a4a8&
var SearchaniseFiltersvue_type_template_id_dea1a4a8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bcsf__filters-wrapper"},[_c('section',{staticClass:"bcsf__filters",staticStyle:{"z-index":"200"}},[_c('div',{staticClass:"filter__group group--sort-by"},[_c('span',{staticClass:"filter__toggle--title"},[_vm._v(_vm._s(_vm.$language.collection.sort_by))]),_vm._v(" "),_c('div',{staticClass:"filter__select select",on:{"click":function($event){_vm.sortByDropdownOpen = !_vm.sortByDropdownOpen;
          _vm.filterDropdownOpen = false;
          _vm.activeFilterGroup = null;}}},[_c('span',{staticClass:"filter__select--active"},[_vm._v(_vm._s(_vm.sortByTitle))]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortByDropdownOpen),expression:"sortByDropdownOpen"}],staticClass:"filter__select--dropdown"},_vm._l((_vm.$options.sortByOptions),function(option){return _c('span',{key:option,on:{"click":function($event){return _vm.setSortBy(option.shopifyApi)}}},[_vm._v("\n              "+_vm._s(option.name)+"\n            ")])}),0)])],1)]),_vm._v(" "),_c('button',{staticClass:"laptop-down",on:{"click":function($event){_vm.mobileFilterDropdownOpen = !_vm.mobileFilterDropdownOpen;
        _vm.filterDropdownOpen = false;
        _vm.activeFilterGroup = null;}}},[_c('span',{staticClass:"filter__toggle--title"},[_vm._v(_vm._s(_vm.$language.collection.filter_by))]),_vm._v(" "),_c('span',{class:[
          'btn--toggle carret',
          { active: _vm.mobileFilterDropdownOpen } ]})]),_vm._v(" "),(
        _vm.$screen.laptop_up
          ? _vm.filterGroups.length
          : _vm.mobileFilterDropdownOpen && _vm.filterGroups.length
      )?_c('div',{staticClass:"filter__group group--filter-by"},[_vm._l((_vm.filterGroups),function(filterGroup,index){return _c('div',{key:index,staticClass:"filter__group--child"},[(filterGroup.type != 'slider')?[_c('button',{class:[
              'filter__toggle',
              { open: _vm.filterDropdownOpen == filterGroup.attribute } ],on:{"click":function($event){return _vm.toggleFilterDropdown(filterGroup)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.countActiveFilterOptions(filterGroup.attribute)),expression:"countActiveFilterOptions(filterGroup.attribute)"}],staticClass:"filter__toggle--count",domProps:{"textContent":_vm._s(_vm.countActiveFilterOptions(filterGroup.attribute))}}),_vm._v(" "),_c('span',{staticClass:"filter__toggle--title"},[_vm._v("\n              "+_vm._s(filterGroup.title)+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"btn--toggle carret",class:[
                { active: _vm.filterDropdownOpen == filterGroup.attribute },
                { right: !_vm.$screen.laptop_up } ]})])]:_vm._e()],2)}),_vm._v(" "),(_vm.priceFilterGroup && !_vm.$screen.laptop_up)?_c('div',{staticClass:"filter-group group--price-range"},[_c('span',{staticClass:"filter__toggle--title"},[_vm._v(_vm._s(_vm.$language.collection.price_range))]),_vm._v(" "),_c('PriceRange',{attrs:{"min":_vm.priceRange.min || Math.floor(_vm.priceFilterGroup.buckets[0].from),"max":_vm.priceRange.max || Math.ceil(_vm.priceFilterGroup.buckets[0].to),"from_prop":_vm.priceRange.from,"to_prop":_vm.priceRange.to},on:{"priceUpdate":_vm.setPriceRange}})],1):_vm._e(),_vm._v(" "),(!_vm.$isEmpty(_vm.activeFilters) && !_vm.$screen.laptop_up)?_c('button',{staticClass:"filter__group--clear-filters",attrs:{"aria-label":"Clear Filters"},on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("\n        "+_vm._s(_vm.$language.collection.clear_filters)+"\n      ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.priceFilterGroup && _vm.$screen.laptop_up)?_c('div',{staticClass:"filter-group group--price-range"},[_c('span',{staticClass:"filter__toggle--title"},[_vm._v(_vm._s(_vm.$language.collection.price_range))]),_vm._v(" "),_c('PriceRange',{attrs:{"min":_vm.priceRange.min || Math.floor(_vm.priceFilterGroup.buckets[0].from),"max":_vm.priceRange.max || Math.ceil(_vm.priceFilterGroup.buckets[0].to),"from_prop":_vm.priceRange.from,"to_prop":_vm.priceRange.to},on:{"priceUpdate":_vm.setPriceRange}})],1):_vm._e()]),_vm._v(" "),(_vm.activeFilterGroup)?[_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filterDropdownOpen),expression:"filterDropdownOpen"}],staticClass:"filter__dropdown",staticStyle:{"z-index":"250"}},[_c('div',{staticClass:"filter__dropdown--count"},[_c('span',[_vm._v("\n            "+_vm._s(_vm.countActiveFilterOptions(_vm.activeFilterGroup.attribute) +
              ' ' +
              _vm.activeFilterGroup.title +
              's selected')+"\n          ")]),_vm._v(" "),(!_vm.$isEmpty(_vm.activeFilters))?_c('button',{staticClass:"filter__dropdown--clear-filters btn--inline",attrs:{"aria-label":"Clear Filters"},on:{"click":function($event){return _vm.clearFilters()}}},[_vm._v("\n            "+_vm._s(_vm.$language.collection.clear_filters)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"filter__dropdown--child"},_vm._l((_vm.activeFilterGroup.buckets),function(option,index){return _c('span',{key:index,staticClass:"filter__option",class:{
              'active-filter':
                _vm.activeFilters[
                  ((_vm.activeFilterGroup.attribute) + ":" + (option.value))
                ],
            },on:{"click":function($event){return _vm.toggleFilterOption(_vm.activeFilterGroup, option.value)}}},[_c('span',[_vm._v(_vm._s(option.value))])])}),0),_vm._v(" "),_c('button',{staticClass:"filter__dropdown--mobile-breadcrumb filter__toggle laptop-down-flex",on:{"click":function($event){_vm.activeFilterGroup = null;
            _vm.filterDropdownOpen = null;}}},[_c('span',{staticClass:"btn--toggle carret left"}),_vm._v(" "),_c('span',{staticClass:"filter__toggle--title"},[_vm._v(_vm._s(_vm.activeFilterGroup.title))])])])])]:_vm._e()],2)}
var SearchaniseFiltersvue_type_template_id_dea1a4a8_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/sessionstorage/index.js
var sessionstorage = __webpack_require__(6986);
var sessionstorage_default = /*#__PURE__*/__webpack_require__.n(sessionstorage);
// EXTERNAL MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.mjs
var vue_composition_api = __webpack_require__(5706);
;// CONCATENATED MODULE: ./src/scripts/vue/store/collection.js

const state = (0,vue_composition_api/* reactive */.qj)({
  products: [],
  filterProductsCount: 0,
  loading: false
});
function useCollection() {
  function getProducts() {
    return (0,vue_composition_api/* computed */.Fl)(() => state.products);
  }

  function setProducts(products, count) {
    state.products = products;
    state.filterProductsCount = count;
  }

  function setLoading(status) {
    state.loading = status;
  }

  return {
    state,
    getProducts,
    setProducts,
    setLoading
  };
}
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/PriceRange.vue?vue&type=template&id=7351bbc8&
var PriceRangevue_type_template_id_7351bbc8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"track-container"},[_c('span',{staticClass:"range-value min"},[_vm._v("\n    $"+_vm._s(_vm.from)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"range-value max"},[_vm._v("\n    $"+_vm._s(_vm.to)+"\n  ")]),_vm._v(" "),_c('div',{ref:"_vpcTrack",staticClass:"track"}),_vm._v(" "),_c('div',{ref:"trackHighlight",staticClass:"track-highlight"}),_vm._v(" "),_c('button',{ref:"track1",staticClass:"track-btn track1"},[_vm._m(0)]),_vm._v(" "),_c('button',{ref:"track2",staticClass:"track-btn track2"},[_vm._m(1)])])}
var PriceRangevue_type_template_id_7351bbc8_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"increase-target-size"},[_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"increase-target-size"},[_c('span')])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/PriceRange.vue?vue&type=template&id=7351bbc8&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/PriceRange.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PriceRangevue_type_script_lang_js_ = ({
  name: 'PriceRange',
  props: ['min', 'max', 'from_prop', 'to_prop'],

  data() {
    return {
      from: this.from_prop || this.min,
      to: this.to_prop || this.max,
      step: 1,
      totalSteps: 0,
      percentPerStep: 1,
      trackWidth: null,
      isDragging: false,
      pos: {
        curTrack: null
      }
    };
  },

  watch: {
    min() {
      this.from = this.min;
      this.updateUX();
    },

    max() {
      this.to = this.max;
      this.updateUX();
    },

    from_prop: {
      handler() {
        this.from = !this.from_prop || this.from_prop < this.min ? this.min : this.from_prop;
      },

      immediate: true
    },
    to_prop: {
      handler() {
        this.to = !this.to_prop || this.to_prop > this.max ? this.max : this.to_prop;
      },

      immediate: true
    }
  },
  methods: {
    moveTrack(track, ev) {
      let percentInPx = this.getPercentInPx();
      let trackX = Math.round(this.$refs._vpcTrack.getBoundingClientRect().left);
      let clientX = ev.clientX;
      let moveDiff = clientX - trackX;
      let moveInPct = moveDiff / percentInPx;
      if (moveInPct < 1 || moveInPct > 100) return;
      let value = Math.round(moveInPct / this.percentPerStep) * this.step + this.min;

      if (track === 'track1') {
        if (value >= this.to - this.step) return;
        this.from = value;
      }

      if (track === 'track2') {
        if (value <= this.from + this.step) return;
        this.to = value;
      }

      this.$refs[track].style.left = moveInPct + '%';
      this.setTrackHightlight();
    },

    mousedown(ev, track) {
      if (this.isDragging) return;
      this.isDragging = true;
      this.pos.curTrack = track;
    },

    touchstart(ev, track) {
      this.mousedown(ev, track);
    },

    mouseup(ev, track) {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.$emit('priceUpdate', `${this.from}, ${this.to}`);
    },

    touchend(ev, track) {
      this.mouseup(ev, track);
      this.$emit('priceUpdate', `${this.from}, ${this.to}`);
    },

    mousemove(ev, track) {
      if (!this.isDragging) return;
      this.moveTrack(track, ev);
    },

    touchmove(ev, track) {
      this.mousemove(ev.changedTouches[0], track);
    },

    valueToPercent(value) {
      return (value - this.min) / this.step * this.percentPerStep;
    },

    setTrackHightlight() {
      this.$refs.trackHighlight.style.left = this.valueToPercent(this.from) + '%';
      this.$refs.trackHighlight.style.width = this.valueToPercent(this.to) - this.valueToPercent(this.from) + '%';
    },

    getPercentInPx() {
      let trackWidth = this.$refs._vpcTrack.offsetWidth;
      let oneStepInPx = trackWidth / this.totalSteps; // 1 percent in px

      let percentInPx = oneStepInPx / this.percentPerStep;
      return percentInPx;
    },

    updateUX() {
      // calc per step value
      this.totalSteps = (this.max - this.min) / this.step; // percent the track button to be moved on each step

      this.percentPerStep = 100 / this.totalSteps; // set track1 initial

      this.$refs.track1.style.left = this.valueToPercent(this.from) + '%'; // track2 initial position

      this.$refs.track2.style.left = this.valueToPercent(this.to) + '%'; // set initial track highlight

      this.setTrackHightlight();
      let actionsArrayOne = ['mouseup', 'mousemove'];
      actionsArrayOne.forEach(type => {
        document.body.addEventListener(type, ev => {
          if (this.isDragging && this.pos.curTrack) {
            this[type](ev, this.pos.curTrack);
          }
        });
      });
      let actionsArrayTwo = ['mousedown', 'mouseup', 'mousemove', 'touchstart', 'touchmove', 'touchend'];
      actionsArrayTwo.forEach(type => {
        document.querySelector('.track1').addEventListener(type, ev => {
          ev.stopPropagation();
          this[type](ev, 'track1');
        });
        document.querySelector('.track2').addEventListener(type, ev => {
          ev.stopPropagation();
          this[type](ev, 'track2');
        });
      });
    }

  },

  mounted() {
    this.updateUX();
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/components/PriceRange.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PriceRangevue_type_script_lang_js_ = (PriceRangevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/PriceRange.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_PriceRangevue_type_script_lang_js_,
  PriceRangevue_type_template_id_7351bbc8_render,
  PriceRangevue_type_template_id_7351bbc8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PriceRange = (component.exports);
// EXTERNAL MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue + 5 modules
var TransitionExpand = __webpack_require__(6719);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/SearchaniseFilters.vue?vue&type=script&lang=js&




/* harmony default export */ var SearchaniseFiltersvue_type_script_lang_js_ = ({
  name: 'SearchaniseFilters',
  components: {
    PriceRange: PriceRange,
    TransitionExpand: TransitionExpand/* default */.Z
  },
  props: ['api_key', 'id', 'handle', 'query', 'productsPerPage', 'page', 'sort_order'],

  setup() {
    const {
      setLoading,
      setProducts
    } = useCollection();
    return {
      setLoading,
      setProducts
    };
  },

  data() {
    return {
      products: [],
      collections: [],
      pages: [],
      historicPage: 0,
      totalProducts: 0,
      filterGroups: [],
      activeFilterGroup: null,
      activeFilters: {},
      activeSortBy: this.sort_order,
      priceRange: {
        active: null,
        min: null,
        max: null,
        from: null,
        to: null
      },
      mobileFilterDropdownOpen: false,
      filterDropdownOpen: false,
      sortByDropdownOpen: false
    };
  },

  computed: {
    sortByTitle() {
      return this.$options.sortByOptions.filter(option => option.shopifyApi.includes(this.activeSortBy)).pop().name || this.sort_order;
    },

    sortByApi() {
      return this.$options.sortByOptions.filter(option => option.shopifyApi.includes(this.activeSortBy)).pop().snizeSortApi || 'relevance';
    },

    sortOrderApi() {
      return this.$options.sortByOptions.filter(option => option.shopifyApi.includes(this.activeSortBy)).pop().snizeOrderApi || 'desc';
    },

    priceFilterGroup() {
      return this.filterGroups.filter(group => group.title === 'Price').pop();
    }

  },

  mounted() {
    this.loadCollection(); // Load previous result set on browser back button

    window.addEventListener('popstate', () => {
      const params = new URLSearchParams(window.location.search);
      const pageNum = Number(params.get('page'));
      this.$emit('updatePage', pageNum);
    });
  },

  watch: {
    products() {
      this.setProducts(this.products, this.totalProducts);
    },

    page() {
      if (this.page === this.historicPage) {
        this.historicPage = 0;
        return;
      }

      window.scroll(0, 150);
      this.getFilteredCollection(this.page);
    }

  },
  methods: {
    async loadCollection() {
      await this.useHistory();
      await this.getFilteredCollection();
    },

    toggleFilterOption(group, value) {
      if (!this.activeFilters[`${group.attribute}:${value}`]) {
        this.activeFilters[`${group.attribute}:${value}`] = group;
      } else {
        delete this.activeFilters[`${group.attribute}:${value}`];
      }

      this.setPriceRange();
      this.getFilteredCollection();
      this.$emit('resetPage');
    },

    toggleFilterDropdown(filterGroup) {
      if (this.activeFilterGroup) {
        if (this.activeFilterGroup.attribute != filterGroup.attribute) {
          this.activeFilterGroup?.buckets.sort((a, b) => a.value.localeCompare(b.value));
          this.filterDropdownOpen = filterGroup.attribute;
          this.sortByDropdownOpen = false;
        } else {
          this.activeFilterGroup = null;
          this.filterDropdownOpen = false;
        }

        this.mobileFilterDropdownOpen = false;
      } else {
        this.activeFilterGroup = filterGroup;
        this.activeFilterGroup?.buckets.sort((a, b) => a.value.localeCompare(b.value));
        this.filterDropdownOpen = filterGroup.attribute;
        this.sortByDropdownOpen = false;
        this.mobileFilterDropdownOpen = true;
      }
    },

    setSortBy(value) {
      this.activeSortBy = value;
      this.getFilteredCollection(this.page);
      this.$emit('resetPage');
    },

    setPriceRange(range) {
      if (range) {
        this.activeFilterGroup = null;
        this.priceRange.active = range;
        this.priceRange.from = Number(range.split(',')[0]);
        this.priceRange.to = Number(range.split(',')[1]);
        this.getFilteredCollection(this.page);
        this.$emit('resetPage');
      } else {
        this.priceRange.active = null;

        if (this.priceFilterGroup) {
          this.priceRange.min = Math.floor(Number(this.priceFilterGroup.buckets[0].from));
          this.priceRange.max = Math.ceil(Number(this.priceFilterGroup.buckets[0].to));
        }
      }
    },

    clearFilters() {
      this.activeFilters = {};
      this.setPriceRange();
      this.getFilteredCollection();
      this.$emit('resetPage');
    },

    countActiveFilterOptions(attr) {
      let count = 0;

      for (const key in this.activeFilters) {
        if (key.includes(attr)) count++;
      }

      return count;
    },

    makeHistory() {
      // save values
      const strFilters = JSON.stringify({
        collection: this.handle,
        activeFilters: this.activeFilters,
        sortBy: this.activeSortBy,
        priceRange: this.priceRange,
        page: this.page
      });
      sessionstorage_default().setItem('PSFilters', strFilters); // update url

      let url = `${globalThis.location.pathname}?`;
      const parameters = new URL(globalThis.location).searchParams;

      if (this.query) {
        url += `q=${this.query}&`;
      }

      url += `page=${this.page}`;
      parameters.forEach((paramValue, paramKey) => {
        if (paramKey !== 'page' || paramKey !== 'q') {
          url += `&${paramKey}=${paramValue}`;
        }
      });
      history.pushState(null, null, url);
    },

    useHistory() {
      const history = JSON.parse(sessionstorage_default().getItem('PSFilters'));
      if (!history) return;

      if (this.handle === history.collection) {
        this.activeFilters = history.activeFilters || {};
        this.activeSortBy = history.sortBy || this.sort_order;

        if (history.priceRange) {
          this.priceRange.active = history.priceRange.active;
          this.priceRange.from = history.priceRange.from || null;
          this.priceRange.to = history.priceRange.to || null;
        }

        if (history.page) {
          this.historicPage = history.page;
          this.$emit('updatePage', history.page);
        }
      } else {
        sessionstorage_default().removeItem('PSFilters');
      }
    },

    async getFilteredCollection(page = 1) {
      this.setLoading(true);
      this.products = []; // Config

      const url = new URL('https://www.searchanise.com/getresults');
      const configParams = {
        api_key: this.api_key,
        maxResults: this.productsPerPage,
        items: true,
        pages: false,
        startIndex: this.page == 1 ? 0 : this.page * this.productsPerPage - this.productsPerPage,
        categories: false,
        facets: true,
        collection: this.handle
      };
      const params = {
        page
      }; // Search query

      if (this.query) {
        params.q = this.query;
        params.pages = true;
        params.categories = true;
      } // Sort


      if (this.sortByApi === 'manual') {
        params.sortBy = `collection_${this.id}_position`;
      } else {
        params.sortBy = this.sortByApi;
      }

      params.sortOrder = this.sortOrderApi;
      Object.keys(configParams).forEach(key => {
        url.searchParams.append(key, configParams[key]);
      });
      Object.keys(params).forEach(key => {
        url.searchParams.append(key, params[key]);
      }); // Price

      if (this.priceRange.active) {
        url.searchParams.append('restrictBy[price]', this.priceRange.active);
      } // Filters


      if (this.activeFilters) {
        const filtersObj = {};

        for (const key in this.activeFilters) {
          if (filtersObj.hasOwnProperty(key.split(':')[0])) {
            filtersObj[key.split(':')[0]] += `|${key.split(':')[1]}`;
          } else {
            filtersObj[key.split(':')[0]] = key.split(':')[1];
          }
        }

        for (const key in filtersObj) {
          url.searchParams.append(`restrictBy[${key}]`, filtersObj[key]);
        }
      } // Send request


      await fetch(url).then(response => response.json()).then(data => {
        if (data.error) {
          if (data.error === 'SORT_ATTRIBUTE_WASNT_FOUND') {
            this.setSortBy('created-descending');
          }
        } else {
          this.totalProducts = data.totalItems;
          this.products = data.items;
          this.filterGroups = data.facets || [];
          const priceFilter = this.filterGroups.filter(group => group.title === 'Price').pop();

          if (priceFilter) {
            this.priceRange.min = Math.floor(Number(priceFilter.buckets[0].from));
            this.priceRange.max = Math.ceil(Number(priceFilter.buckets[0].to));
          }

          this.setLoading(false);
          this.makeHistory();
        }
      }).catch(error => {
        console.log('error', error);
      });
    }

  },
  sortByOptions: [{
    name: 'Alphabetically, A-Z',
    shopifyApi: 'title-ascending',
    snizeSortApi: 'title',
    snizeOrderApi: 'asc'
  }, {
    name: 'Alphabetically, Z-A',
    shopifyApi: 'title-descending',
    snizeSortApi: 'title',
    snizeOrderApi: 'desc'
  }, {
    name: 'Date, New to old',
    shopifyApi: 'created-descending',
    snizeSortApi: 'created',
    snizeOrderApi: 'desc'
  }, {
    name: 'Date, Old to new',
    shopifyApi: 'created-ascending',
    snizeSortApi: 'created',
    snizeOrderApi: 'asc'
  }, {
    name: 'Lowest Price',
    shopifyApi: 'price-ascending',
    snizeSortApi: 'price',
    snizeOrderApi: 'asc'
  }, {
    name: 'Highest Price',
    shopifyApi: 'price-descending',
    snizeSortApi: 'price',
    snizeOrderApi: 'desc'
  }, {
    name: 'Featured',
    shopifyApi: 'manual',
    snizeSortApi: 'manual',
    snizeOrderApi: 'asc'
  }, {
    name: 'Relevance',
    shopifyApi: 'relevance-descending',
    snizeSortApi: 'relevance',
    snizeOrderApi: 'desc'
  }, {
    name: 'Best Selling',
    shopifyApi: 'best-selling-descending',
    snizeSortApi: 'sales_amount',
    snizeOrderApi: 'desc'
  }]
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/SearchaniseFilters.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SearchaniseFiltersvue_type_script_lang_js_ = (SearchaniseFiltersvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/SearchaniseFilters.vue





/* normalize component */
;
var SearchaniseFilters_component = (0,componentNormalizer/* default */.Z)(
  components_SearchaniseFiltersvue_type_script_lang_js_,
  SearchaniseFiltersvue_type_template_id_dea1a4a8_render,
  SearchaniseFiltersvue_type_template_id_dea1a4a8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SearchaniseFilters = (SearchaniseFilters_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/SearchaniseItem.vue?vue&type=template&id=39f815d8&
var SearchaniseItemvue_type_template_id_39f815d8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"product-item",attrs:{"href":_vm.url,"title":("Product: " + _vm.title),"aria-label":("Product: " + _vm.title)}},[_c('div',{staticClass:"product-item__image-wrapper",staticStyle:{"--aspect-ratio":".65"},on:{"mouseover":function($event){_vm.hover = _vm.$screen.laptop_up},"mouseleave":function($event){_vm.hover = false}}},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeImage),expression:"activeImage"}],key:_vm.key,staticClass:"product-item__main-img lazyload",class:{ 'lazyload': _vm.hover, 'remove-transition': _vm.lazyloaded },attrs:{"data-src":_vm.activeImage,"alt":_vm.$attrs.alt || 'Image'},on:{"lazyloaded":function($event){_vm.lazyloaded += 1}}})]),_vm._v(" "),(_vm.hoverImage)?_c('img',{key:_vm.key,staticClass:"product-item__hover-img lazyload",class:{ 'hovering': _vm.hover, 'remove-transition': _vm.lazyloaded },attrs:{"data-src":_vm.hoverImage,"alt":_vm.$attrs.alt || 'Image'},on:{"lazyloaded":function($event){_vm.lazyloaded += 1}}}):_vm._e(),_vm._v(" "),(_vm.label || (_vm.hover && _vm.variants.length > 1))?_c('div',{staticClass:"product-item__label",style:(_vm.labelStyle)},[(_vm.hover && _vm.variants.length > 1)?_c('div',{staticClass:"product-item__variants"},_vm._l((_vm.variants),function(variant){return _c('span',{key:variant.variant_id,class:{ 'disabled': variant.available !== '1' }},[_vm._v("\n          "+_vm._s(Object.entries(variant.options)[0][1])+"\n        ")])}),0):_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e(),_vm._v(" "),(_vm.lazyloaded < 3)?_c('Loading',{attrs:{"activated":_vm.lazyloaded == 0 || _vm.hover}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"product-item__vendor"},[_vm._v("\n    "+_vm._s(_vm.product.vendor)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"product-item__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"product-item__price"},[_c('span',{staticClass:"money"},[_vm._v(_vm._s(_vm.$money(_vm.price)))]),_vm._v(" "),(_vm.salePrice)?_c('span',{staticClass:"product__sale-price"},[_c('s',[_c('span',{staticClass:"money"},[_vm._v(_vm._s(_vm.$money(_vm.salePrice)))])])]):_vm._e()]),_vm._v(" "),_c('div',{ref:"insert-wishlist",staticClass:"product-item__wishlist"})])}
var SearchaniseItemvue_type_template_id_39f815d8_staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/vue/components/VImg.vue + 3 modules
var VImg = __webpack_require__(3023);
// EXTERNAL MODULE: ./src/scripts/vue/components/Loading.vue + 4 modules
var Loading = __webpack_require__(9918);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/SearchaniseItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var SearchaniseItemvue_type_script_lang_js_ = ({
  name: 'SearchaniseItem',
  components: {
    VImg: VImg/* default */.Z,
    Loading: Loading/* default */.Z
  },
  props: ['product', 'collection', 'label_conf'],

  data() {
    return {
      key: 0,
      hover: false,
      lazyloaded: 0,
      imageSize: '550x'
    };
  },

  computed: {
    title() {
      return this.product.title.replace(this.product.vendor, '').trim();
    },

    url() {
      return this.product.link;
    },

    price() {
      return Number(this.product.price) * 100;
    },

    salePrice() {
      return Number(this.product.list_price) * 100;
    },

    images() {
      return this.product.shopify_images;
    },

    activeImage() {
      if (this.images.length === 0) return window.PSTheme.Settings.NoImage;
      return this.images[0];
    },

    hoverImage() {
      if (this.images.length > 1) return this.images[1];
    },

    variants() {
      return this.product.shopify_variants;
    },

    tags() {
      return this.product.tags.split('[:ATTR:]');
    },

    label() {
      if (window.PSTheme.Settings.Outlet && this.salePrice) {
        let discount = Math.round(100 - 100 * (this.price / this.salePrice));
        return discount + '% off';
      }

      let label = this.tags ? this.tags.find(tag => tag.includes('Label:')) : '';
      if (label) return label.replace('Label: ', '');
    },

    labelStyle() {
      let conf = this.label_conf ? this.label_conf[this.label] : null;
      let defaultStyle = window.PSTheme.Settings.Outlet ? 'color: var(--red); background: var(--soft-pink);' : 'color: var(--sage); background: var(--mint);';
      return conf ? `color: ${conf.color}; background: ${conf.background};` : defaultStyle;
    }

  },

  created() {
    let preloadImages = [];
    if (this.images) preloadImages.push(this.images[0].src ? this.images[0].src.replace('_large', '') : this.images[0].replace('_large', ''));
    if (this.images.length > 1) preloadImages.push(this.images[1].src ? this.images[1].src.replace('_large', '') : this.images[1].replace('_large', ''));
    this.$preloadImages(preloadImages, this.imageSize);
  },

  mounted() {
    if (window.PSTheme.Settings.Outlet === false) {
      let wishlist_btn = document.createComment(` include 'wishlist-button-collection' with '${this.product.product_id}' `);
      this.$refs['insert-wishlist'].appendChild(wishlist_btn);
    }
  },

  watch: {
    // re-render the template programmatically
    activeImage: {
      handler() {
        this.key = Math.random() * (999 - 0 + 1) << 0;
      },

      deep: true
    }
  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/SearchaniseItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SearchaniseItemvue_type_script_lang_js_ = (SearchaniseItemvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/SearchaniseItem.vue





/* normalize component */
;
var SearchaniseItem_component = (0,componentNormalizer/* default */.Z)(
  components_SearchaniseItemvue_type_script_lang_js_,
  SearchaniseItemvue_type_template_id_39f815d8_render,
  SearchaniseItemvue_type_template_id_39f815d8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SearchaniseItem = (SearchaniseItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/PlaceholderItem.vue?vue&type=template&id=44423538&functional=true&
var PlaceholderItemvue_type_template_id_44423538_functional_true_render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.type == 'product-item')?_c('div',{staticClass:"placeholder__container"},[_c('div',{staticClass:"placeholder__image",style:(("--aspect-ratio:" + (_vm.props.ratio)))}),_vm._v(" "),_c('p',{staticClass:"placeholder__text first"}),_vm._v(" "),_c('p',{staticClass:"placeholder__text"}),_vm._v(" "),_c('p',{staticClass:"placeholder__text"})]):_c('div',{staticClass:"placeholder__container",style:(("--aspect-ratio:" + (_vm.props.ratio)))},[_c('div',{staticClass:"placeholder__random"})])}
var PlaceholderItemvue_type_template_id_44423538_functional_true_staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/PlaceholderItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var PlaceholderItemvue_type_script_lang_js_ = ({
  name: 'PlaceholderItem',
  props: ['type', 'ratio']
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/PlaceholderItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PlaceholderItemvue_type_script_lang_js_ = (PlaceholderItemvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/components/PlaceholderItem.vue





/* normalize component */
;
var PlaceholderItem_component = (0,componentNormalizer/* default */.Z)(
  components_PlaceholderItemvue_type_script_lang_js_,
  PlaceholderItemvue_type_template_id_44423538_functional_true_render,
  PlaceholderItemvue_type_template_id_44423538_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var PlaceholderItem = (PlaceholderItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/templates/Collection.vue?vue&type=script&lang=js&





/* harmony default export */ var Collectionvue_type_script_lang_js_ = ({
  name: 'Collection',
  props: ['shop', 'api_key', 'id', 'handle', 'products_count', 'sort_order', 'template', 'query'],
  components: {
    SearchaniseFilters: SearchaniseFilters,
    SearchaniseItem: SearchaniseItem,
    PlaceholderItem: PlaceholderItem,
    Pagination: (vue_plain_pagination_umd_min_default())
  },

  setup() {
    const {
      state
    } = useCollection();
    return {
      state
    };
  },

  data() {
    return {
      productsPerPage: 20,
      currentPage: 1,
      queryActive: false,
      label_conf: []
    };
  },

  computed: {
    numberOfPages() {
      return Math.ceil(this.state.filterProductsCount / this.productsPerPage);
    }

  },

  mounted() {
    fetch('/collections/all?view=labels').then(res => res.json()).then(data => {
      this.label_conf = JSON.parse(data);
    });
  },

  paginationClasses: {
    li: 'pagination__part',
    liActive: 'active',
    button: 'pagination__button'
  },
  paginationLabels: {
    prev: ' ',
    next: ' '
  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/templates/Collection.vue?vue&type=script&lang=js&
 /* harmony default export */ var templates_Collectionvue_type_script_lang_js_ = (Collectionvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/scripts/vue/templates/Collection.vue





/* normalize component */
;
var Collection_component = (0,componentNormalizer/* default */.Z)(
  templates_Collectionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Collection = (Collection_component.exports);

/***/ }),

/***/ 6719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TransitionExpand; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=template&id=1b12723a&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expand"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default")],2)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var TransitionExpandvue_type_script_lang_js_ = ({
  name: 'TransitionExpand',
  props: {
    fixedEntryHeight: {
      type: String,
      required: false,
      default: null
    },
    linear_padding: {
      type: String,
      required: false,
      default: ''
    },
    linear_margin: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    enter(element) {
      element.style.height = this.fixedEntryHeight || element.scrollHeight + 'px';
      element.style.opacity = 1;

      if (this.linear_padding !== '') {
        element.style.paddingTop = this.linear_padding;
        element.style.paddingBottom = this.linear_padding;
      }

      if (this.linear_margin !== '') {
        element.style.marginTop = this.linear_margin;
        element.style.marginBottom = this.linear_margin;
      }
    },

    afterEnter(element) {
      element.style.height = 'auto';
    },

    leave(element) {
      element.style.height = element.scrollHeight + 'px';
      setTimeout(() => {
        element.style.height = 0;
        element.style.opacity = 0;

        if (this.linear_padding !== '') {
          element.style.paddingTop = 0;
          element.style.paddingBottom = 0;
        }

        if (this.linear_margin !== '') {
          element.style.marginTop = 0;
          element.style.marginBottom = 0;
        }
      }, 50);
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=script&lang=js&
 /* harmony default export */ var transitions_TransitionExpandvue_type_script_lang_js_ = (TransitionExpandvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(3379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(7795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(3565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(9216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(4589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&
var TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_ = __webpack_require__(9863);
;// CONCATENATED MODULE: ./node_modules/style-loader/dist/cjs.js!./node_modules/@ps-devs/shopify-webpack/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5[0].rules[0].use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default */.Z, options);




       /* harmony default export */ var transitions_TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_ = (TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default */.Z && TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default.locals */.Z.locals ? TransitionExpandvue_type_style_index_0_id_1b12723a_scoped_true_lang_css_/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue?vue&type=style&index=0&id=1b12723a&scoped=true&lang=css&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/transitions/TransitionExpand.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  transitions_TransitionExpandvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1b12723a",
  null
  
)

/* harmony default export */ var TransitionExpand = (component.exports);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346,383,790], function() { return __webpack_exec__(9887); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);